import lottieReact from "lottie-react";
import { cjsDefault } from "../../lib/cjs-default";
import { useTranslation } from "react-i18next";
import loadingAnimation from "../../assets/animations/juiscigpt-chat-loading.json";

const Lottie = cjsDefault(lottieReact);

type ChatLoaderVariant = "juiscigpt" | "cwyop";

type ChatLoaderProps = {
  variant?: ChatLoaderVariant;
};

function MintBouncingDots(): React.ReactElement {
  return (
    <div className="flex items-end gap-[8px] h-[22px]">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="size-[22px] rounded-full animate-[chatLoaderBounce_1.2s_ease-in-out_infinite]"
          style={{
            backgroundColor: "var(--color-ds-primary)",
            opacity: 0.5 + i * 0.2,
            animationDelay: `${String(i * 0.15)}s`,
          }}
        />
      ))}
    </div>
  );
}

export function ChatLoader({
  variant = "juiscigpt",
}: ChatLoaderProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div className="py-[100px] flex flex-col items-center gap-[7px] opacity-0 animate-[fadeIn_ease-in_0.5s_forwards]">
      {variant === "cwyop" ? (
        <MintBouncingDots />
      ) : (
        <Lottie
          animationData={loadingAnimation}
          className="w-32"
          loop
          autoplay
        />
      )}
      <p className="font-dm-sans font-light text-[10px] leading-[15px] text-[#004852] text-center m-0">
        {t("Juisci will reply shortly...")}
      </p>
    </div>
  );
}
